import React from 'react'
import { useSelector } from 'react-redux'
import { selectVerified } from '@/public/redux/recaptchaSlice'
import { selectPaymentRequestOpen } from '@/public/redux/cartSlice'

// onRemove is opt-in: the cart passes it so "-" at 1 removes the line, while
// product pages, which have nothing to remove, keep the floor at 1.
export default function QuantityInput({ quantity = 1, handleChange, onRemove }) {
  const verified = useSelector(selectVerified)
  const paymentRequestOpen = useSelector(selectPaymentRequestOpen)

  const handleDecrement = (e) => {
    e.stopPropagation()

    if (!verified) { return }

    if (quantity > 1) {
      handleChange(quantity - 1)
    } else if (onRemove) {
      onRemove(e)
    }
  }

  const handleIncrement = (e) => {
    e.stopPropagation()

    if (verified) {
      const newQuantity = quantity + 1
      handleChange(newQuantity)
    }
  }

  const handleInputChange = (e) => {
    e.stopPropagation()

    if (verified) {
      const value = e.target.value
      handleChange(Number(value))
    }
  }

  return (
    <div className="incrementor">
      <div
        className={`minus ${paymentRequestOpen ? 'payment-request-open' : ''}`}
        onClick={handleDecrement}
      >
        <i className="icon-minus" />
      </div>

      <input
        type="text"
        value={quantity}
        disabled={!verified}
        onChange={handleInputChange}
      />

      <div
        className={`plus ${paymentRequestOpen ? 'payment-request-open' : ''}`}
        onClick={handleIncrement}
      >
        <i className="icon-plus" />
      </div>
    </div>
  )
}
